/* Built In Imports */
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData, filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import { fetchSadhguruPageData } from 'services/sadhguruService';

const getSubscriptionText = newsletter => {
  let text = '';
  switch (newsletter) {
    case 'EnglishNewsletter':
      text = 'Isha Weekly Newsletter';
      break;
    case 'TamilNewsletter':
      text = 'Isha Tamil Newsletter';
      break;
    case 'HindiNewsletter':
      text = 'Isha Hindi Newsletter';
      break;
    case 'DMQ':
      text = 'Sadhguru Quotes';
      break;
    case 'IshaKriya':
      text = 'Isha Kriya Mandala';
      break;
    case 'ForestFlower':
      text = 'Isha Forest Flower';
      break;
    case 'IshaLahar':
      text = 'Isha Lahar';
      break;
    case 'Ishakaattupoo':
      text = 'Isha Kaattupoo';
      break;
    default:
      text = 'Newsletter';
  }
  return text;
};

const getContent = ({ what1, txnstatus }) => {
  let content = '';
  if (txnstatus === '101' || txnstatus === '102') {
    content = (
      <Box>
        <Text pb="30px">Namaskaram,</Text>

        <Text pb="30px">
          To complete your subscription, please follow these steps:
        </Text>

        <Text pb="30px">
          a. Please check your inbox for an email with the subject line “Please
          confirm your{' '}
          <Text as="span" color="#cf4824">
            {`${
              getSubscriptionText(what1) ? `${getSubscriptionText(what1)} ` : ''
            }`}
          </Text>
          subscription”.
        </Text>

        <Text pb="30px">
          b. Then click on the link in the email to verify your email ID.
        </Text>

        <Text pb="30px">
          If you do not find the email from us in the Primary Inbox, please
          check the Promotions folder for the same and move the mail to the
          Primary Inbox.
        </Text>

        <Text>Pranam,</Text>
        <Text>Isha Volunteers</Text>
      </Box>
    );
  } else if (txnstatus === '103') {
    content = (
      <Box>
        <Text pb="30px">Namaskaram,</Text>

        <Text pb="30px">
          You have already subscribed to{' '}
          <Text as="span" color="#cf4824">
            {`${
              getSubscriptionText(what1) ? `${getSubscriptionText(what1)} ` : ''
            }`}
          </Text>
          .
        </Text>

        <Text pb="30px">
          If you are not receiving emails for the newsletter in your Primary
          Inbox, please check your Promotions folder and move the emails to the
          Primary Inbox.
        </Text>

        <Text pb="30px">
          If you face any issues, please contact the Isha Email Team at{' '}
          <Link
            color="#cf4824"
            _hover={{
              textDecoration: 'none',
            }}
          >
            emailteam.support@isha.sadhguru.org
          </Link>
          .
        </Text>

        <Text>Pranam,</Text>
        <Text>Isha Volunteers</Text>
      </Box>
    );
  } else if (txnstatus === '104' || txnstatus === '105') {
    content = (
      <Box>
        <Text pb="30px">Namaskaram,</Text>

        <Text pb="30px">
          We are unable to add this email ID to our system. Sorry about that.
        </Text>

        <Text pb="30px">
          Please contact the Isha Email Team at{' '}
          <Link
            color="#cf4824"
            _hover={{
              textDecoration: 'none',
            }}
          >
            emailteam.support@isha.sadhguru.org
          </Link>{' '}
          and we will help you complete your subscription.
        </Text>

        <Text>Pranam,</Text>
        <Text>Isha Volunteers</Text>
      </Box>
    );
  } else if (txnstatus === '106') {
    content = (
      <Box textAlign="center">
        Congratulations, your subscription is now complete.
      </Box>
    );
  }
  return content;
};

/**
 *
 * @param root0
 * @param root0.headerMenuData
 * @param root0.region
 * @param root0.language
 * @param root0.footerData
 * @param root0.pageData
 * @param root0.page
 */
export default function SubscribeConfirmation({
  headerMenuData,
  region,
  language,
  footerData,
  pageData,
  page,
}) {
  const router = useRouter();
  const { where, what1, txnstatus } = router.query;
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      {/* <Header
      headerMenuData={headerMenuData}
      availableLocals={pageData.availableLocales}
      currentUserRegion={currentUserRegion}
      setCurrentUserRegion={(val) => setCurrentUserRegion(val)}
      region={region}
      language={language}
    /> */}
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url={pageData.url}
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box
        fontFamily="FedraSansStd-book"
        fontSize={{ base: '16px', sm: '16px', md: '18px' }}
        color="#28231e"
        lineHeight="1.61"
        //width="42%"
        width={{ base: '100%', sm: '100%', md: '42%' }}
        m="0 auto"
        p={{
          base: '37px 20px 94px 20px',
          sm: '37px 20px 94px 20px',
          md: '80px 20px 100px 20px',
        }}
      >
        {getContent({ what1, txnstatus })}
      </Box>
    </WrapLayout>
  );
}

// const getLocale = (region, language) => {
//   return region === 'global' ? language : `${language}-${region.toUpperCase()}`;
// };

export const getStaticPaths = async () => {
  let subscribeConfirmPath = [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    subscribeConfirmPath = filterBuildUrls('sadhguru', 'lvl0', '/subscribe-confirmation', '', data);
  }
  else if (config.BUILD_URLS?.LANDING_PAGES?.SubscribeConfirm) {
    subscribeConfirmPath = [
      `/in/en/subscribe-confirmation`,
      `/in/hi/subscribe-confirmation`,
      `/in/ta/subscribe-confirmation`,
      `/au/en/subscribe-confirmation`,
      `/ca/en/subscribe-confirmation`,
      `/my/en/subscribe-confirmation`,
      `/sg/en/subscribe-confirmation`,
      `/uk/en/subscribe-confirmation`,
      `/us/en/subscribe-confirmation`,
      `/eu/en/subscribe-confirmation`,
      `/global/en/subscribe-confirmation`,
      `/global/de/subscribe-confirmation`,
      `/global/ar/subscribe-confirmation`,
      `/global/ru/subscribe-confirmation`,
      `/global/es/subscribe-confirmation`,
      `/global/fr/subscribe-confirmation`,
      `/global/zh/subscribe-confirmation`
    ]
  }
  return {
    paths: subscribeConfirmPath,
    fallback: false,
  };
};

export const getStaticProps = async ({
  // preview,
  // previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchSadhguruPageData(
    region,
    language
    //   {
    //   preview,
    //   data: previewData,
    // }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      // isPreview: preview ? true : false,
    },
  };
};
